<template>
  <v-row density="comfortable">
    <v-col cols="12" class="d-flex justify-center">
      <v-card
        variant="outlined"
        width="500px"
        class="d-flex flex-column align-center pa-2 transparent-card"
      >
        <div class="d-flex align-center mb-2">
          <v-icon class="mr-1" :icon="mdiInformationOutline" />
          <sf-title>{{ $t('featureAd.comparison.title') }}</sf-title>
        </div>
        <sf-text class="my-2 text-center">{{ $t('featureAd.comparison.description') }}</sf-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import SfText from '@/components/text/SfText.vue'
import SfTitle from '@/components/text/SfTitle.vue'
import { mdiInformationOutline } from '@mdi/js'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ProductComparisonHint',
  components: {
    SfText,
    SfTitle
  },
  setup() {
    return {
      mdiInformationOutline
    }
  }
})
</script>
